import * as types from '../types.js';
import { getSialApiHost } from '../api.js';

function esc(s)
{
	if (s == null || s === '')
		return '';
	const t = String(s);
	return t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function _dirPt(d)
{
	if (d === 'inbound')
		return 'Entrada';
	if (d === 'outbound')
		return 'Saída';
	return d ? String(d) : '—';
}

/** Coluna Integradas: inbound só com fetched > 0; outbound só se sent/picked/failure tiver algum > 0 (texto vem da API). */
/** Prévia curta na grade para request/response (obj ou string truncada na API) ou stack. */
function payloadCellPreview(value)
{
	if (value == null || value === '')
		return '—';
	if (typeof value === 'string')
	{
		const t = value.length > 100 ? `${value.slice(0, 100)}…` : value;
		return esc(t);
	}
	try
	{
		const s = JSON.stringify(value);
		const t = s.length > 100 ? `${s.slice(0, 100)}…` : s;
		return esc(t);
	}
	catch (e)
	{
		return esc(String(value));
	}
}

function formatPortalIntegradas(record)
{
	const d = String(record.direction || '').toLowerCase();
	if (d === 'outbound')
	{
		const s = record.outbound_stats;
		return s ? esc(String(s)) : '';
	}
	const f = record.fetched;
	if (f != null && Number(f) > 0)
		return esc(String(f));
	return '';
}

/** ID da inbox TechHub ligado ao evento (para processar fila por checkbox). */
function _techhubInboxId(record)
{
	const et = String(record.entity_type || '').toLowerCase();
	if (et !== 'techhub_inbox')
		return null;
	const v = record.entity_id;
	if (v == null || v === '')
		return null;
	const s = String(v).trim();
	return /^\d+$/.test(s) ? s : null;
}

/** Legenda de status WMS (SESSP) — referência para correlacionar códigos enviados/recebidos na integração. */
const SESSP_WMS_STATUS_LEGEND = [
	['1', 'WMS', 'Integrado API', 'Fatura recepcionada pela API do WMS'],
	['I', 'WMS', 'Checando Saldo', 'Checando saldo de estoque.'],
	['A', 'WMS', 'Reservado', 'Pedido registrado e itens reservados no estoque.'],
	['O', 'WMS', 'Onda Gerada', 'Onda de separação gerada.'],
	['S', 'WMS', 'Separação', 'Itens estão sendo separados para envio.'],
	['F', 'WMS', 'Conferência', 'Pedido em conferência.'],
	['X', 'WMS', 'Etiquetagem de volumes', 'Em processo de etiquetagem de volumes'],
	['G', 'WMS', 'Aguardando Expedição', 'Pronto para envio, aguardando liberação da expedição'],
	['C', 'WMS', 'Cancelado', 'Pedido cancelado e não será processado.'],
];

function _sesspWmsStatusLegendHtml()
{
	const rows = SESSP_WMS_STATUS_LEGEND.map(
		([id, sys, name, desc]) =>
			`<tr>
				<td><code>${esc(id)}</code></td>
				<td>${esc(sys)}</td>
				<td>${esc(name)}</td>
				<td>${esc(desc)}</td>
			</tr>`
	).join('');
	return `
			<div style="margin-top:0.65rem;">
				<div style="font-weight:600;font-size:0.88rem;margin-bottom:0.4rem;">Legenda — status WMS</div>
				<div style="overflow-x:auto;">
					<table class="integration-wms-status-legend" style="width:100%;border-collapse:collapse;font-size:0.82rem;border:1px solid var(--color-border,#ccc);">
						<thead>
							<tr style="background:var(--color-muted-bg,rgba(0,0,0,0.06));text-align:left;">
								<th style="padding:0.35rem 0.5rem;border-bottom:1px solid var(--color-border,#ccc);white-space:nowrap;">id_origem</th>
								<th style="padding:0.35rem 0.5rem;border-bottom:1px solid var(--color-border,#ccc);white-space:nowrap;">Sistema</th>
								<th style="padding:0.35rem 0.5rem;border-bottom:1px solid var(--color-border,#ccc);">nome_status</th>
								<th style="padding:0.35rem 0.5rem;border-bottom:1px solid var(--color-border,#ccc);">descricao_status</th>
							</tr>
						</thead>
						<tbody>${rows}</tbody>
					</table>
				</div>
			</div>`;
}

/** Cabeçalho SESSP (TechHub/IBL + GSNET Entrada) — ativado pela API quando INTEGRATION_CENTRAL_BANNER=sessp */
function _bannerAggLines(agg, labelFn)
{
	if (!agg || !agg.length)
		return `<div style="margin-top:0.25rem;color:var(--color-muted,#444);">Nenhum evento ${esc(labelFn(''))} neste período.</div>`;
	return agg.map((a) => {
		const key = labelFn(a.integration_key || '—');
		const fails = a.fail_period ?? 0;
		const last = a.last_at != null ? esc(String(a.last_at)) : '—';
		const failTxt = fails === 0 ? 'nenhuma falha no período' : `${fails} falha(s) no período`;
		return `<div style="margin-top:0.2rem;">• <strong>${esc(key)}</strong> — ${_dirPt(a.direction)}: último evento <code style="font-size:0.85em;">${last}</code> · ${failTxt}</div>`;
	}).join('');
}

function _gsnetHealthHtml(summary)
{
	const h = summary.gsnet_health;
	if (!h || typeof h !== 'object')
		return '';
	const counts = h.counts && typeof h.counts === 'object' ? h.counts : {};
	const parts = Object.keys(counts).sort().map((k) => `${esc(k)}: ${esc(String(counts[k]))}`);
	const dry = h.dry_run ? ' · <em>dry-run</em>' : '';
	return `<div style="margin-top:0.35rem;font-size:0.82rem;color:var(--color-muted,#555);">Fila GSNET (todas empresas): ${parts.length ? parts.join(' · ') : '—'}${dry}</div>`;
}

function _healthBannerSesspHtml(summary)
{
	const thAgg = summary.banner_aggregates != null ? summary.banner_aggregates : (summary.aggregates || []).filter((a) => String(a.integration_key || '').toLowerCase().startsWith('techhub'));
	const gsAgg = summary.banner_aggregates_gsnet || (summary.aggregates || []).filter((a) => String(a.integration_key || '').toLowerCase() === 'gsnet_entry');
	const thLines = _bannerAggLines(thAgg, (k) => (String(k).toLowerCase() === 'techhub_ibl' ? 'TechHub — IBL' : String(k || 'TechHub')));
	const gsLines = _bannerAggLines(gsAgg, () => 'GSNET Entrada');
	const notes = (summary.notes || []).map((n) => `<div style="margin-top:0.25rem;">${esc(n)}</div>`).join('');
	return `
		<div class="integration-health-banner" style="margin:0.5rem 0 1rem;padding:0.75rem 1rem;border:1px solid var(--color-border,#ccc);border-radius:6px;background:var(--color-panel,#f9f9f9);font-size:0.9rem;">
			<div style="font-weight:bold;margin-bottom:0.35rem;">Integração SESSP</div>
			<div style="color:var(--color-muted,#444);font-size:0.88rem;">Resumo das últimas <strong>${esc(String(summary.period_hours ?? 24))}</strong> horas.</div>
			<div style="margin-top:0.65rem;font-weight:600;font-size:0.88rem;">TechHub / IBL</div>
			${_sesspWmsStatusLegendHtml()}
			${thLines}
			<div style="margin-top:0.45rem;font-size:0.82rem;color:var(--color-muted,#555);">Use <strong>Filtrar integração: TechHub (IBL)</strong> para ver só <code>techhub_ibl</code>.</div>
			<div style="margin-top:0.65rem;font-weight:600;font-size:0.88rem;">GSNET Entrada (Prodesp)</div>
			${gsLines}
			${_gsnetHealthHtml(summary)}
			<div style="margin-top:0.35rem;font-size:0.82rem;color:var(--color-muted,#555);">Use <strong>Filtrar integração: GSNET Entrada</strong>. Envio automático após conclusão do endereçamento; reenvio manual pela linha selecionada.</div>
			<div style="margin-top:0.5rem;font-size:0.82rem;color:var(--color-muted,#666);border-top:1px solid var(--color-border,#ddd);padding-top:0.45rem;">
				${notes}
			</div>
		</div>`;
}

function _healthBannerHtml(summary)
{
	if (!summary)
		return '';
	if (summary.banner_mode === 'sessp')
		return _healthBannerSesspHtml(summary);
	const p = summary.runner?.protheus;
	const st = p?.status || '—';
	const stClass = st === 'ok' ? 'integration-health-ok' : st === 'stale' ? 'integration-health-warn' : 'integration-health-bad';
	const rows = (summary.aggregates || []).map((a) =>
		`${a.integration_key} ${a.direction || '—'}: último ${a.last_at || '—'} (${a.fail_period ?? 0} falhas no período)`
	).join(' · ');
	return `
		<div class="integration-health-banner" style="margin:0.5rem 0 1rem;padding:0.75rem 1rem;border:1px solid var(--color-border,#ccc);border-radius:6px;background:var(--color-panel,#f9f9f9);font-size:0.9rem;">
			<div style="font-weight:bold;margin-bottom:0.35rem;">Saúde das integrações</div>
			<div><strong>Conector Protheus</strong> — <span class="${stClass}">${esc(st)}</span>${p?.last_heartbeat_at ? ` · último heartbeat: ${esc(String(p.last_heartbeat_at))}` : ''}</div>
			<div style="margin-top:0.25rem;"><strong>Espelho inbound (API)</strong> — ${summary.mirror_inbound_enabled ? 'ativo' : 'desligado (env)'}</div>
			<div style="margin-top:0.35rem;color:var(--color-muted,#444);">${esc(rows || 'Sem eventos no período.')}</div>
			<div style="margin-top:0.45rem;font-size:0.82rem;color:var(--color-muted,#666);">${esc((summary.notes || []).join(' '))}</div>
			${p?.hint ? `<div style="margin-top:0.35rem;font-size:0.82rem;">${esc(p.hint)}</div>` : ''}
		</div>
		<style>
			.integration-health-ok { color: #0a6e0a; font-weight: 600; }
			.integration-health-warn { color: #a65f00; font-weight: 600; }
			.integration-health-bad { color: #b00020; font-weight: 600; }
		</style>`;
}

export default async function(records)
{
	let banner = '';
	try
	{
		const base = getSialApiHost();
		const r = await fetch(`${base}/integration-events/summary?hours=24&stale_minutes=12`, { credentials: 'include' });
		if (r.ok)
			banner = _healthBannerHtml(await r.json());
	}
	catch (e) { /* evita quebrar a grade */ }

	return banner + `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: right; }
			.view td:nth-child(3)	{ text-align: center; }
			.view td:nth-child(4)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(5)	{ text-align: center; max-width: 5rem; }
			.view td:nth-child(6)	{ text-align: center; max-width: 5rem; }
			.view td:nth-child(7)	{ text-align: left; max-width: 24rem; }
			.view td:nth-child(8)	{ text-align: center; max-width: 6rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(11)	{ text-align: left; max-width: 16rem; }
			.view td:nth-child(12)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(13)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(14)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(15)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(16)	{ text-align: left; max-width: 10rem; font-size: 0.82rem; }
			.view td:nth-child(17)	{ text-align: left; max-width: 10rem; font-size: 0.82rem; }
			.view td:nth-child(18)	{ text-align: left; max-width: 10rem; font-size: 0.82rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Evento</th>
					<th data-index="2" data-visible="${this.visible[1]}">Data/Hora</th>
					<th data-index="3" data-visible="${this.visible[2]}">Empresa</th>
					<th data-index="4" data-visible="${this.visible[3]}">Integração</th>
					<th data-index="5" data-visible="${this.visible[4]}">Direção</th>
					<th data-index="6" data-visible="${this.visible[5]}">Status</th>
					<th data-index="7" data-visible="${this.visible[6]}">Resumo</th>
					<th data-index="8" data-visible="${this.visible[7]}">Integradas</th>
					<th data-index="9" data-visible="${this.visible[8]}">Tipo</th>
					<th data-index="10" data-visible="${this.visible[9]}">ID entidade</th>
					<th data-index="11" data-visible="${this.visible[10]}">Erro</th>
					<th data-index="12" data-visible="${this.visible[11]}">Correlação</th>
					<th data-index="13" data-visible="${this.visible[12]}">Origem</th>
					<th data-index="14" data-visible="${this.visible[13]}">Registrado por</th>
					<th data-index="15" data-visible="${this.visible[14]}">Request</th>
					<th data-index="16" data-visible="${this.visible[15]}">Response</th>
					<th data-index="17" data-visible="${this.visible[16]}">Stack</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async record =>
				`<tr data-id='${JSON.stringify([record.id, _techhubInboxId(record)])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([record.id, _techhubInboxId(record)]))}></td>
					<td data-visible='${this.visible[0]}'>${record.id}</td>
					<td data-visible='${this.visible[1]}'>${this.format(types.datetime(), record.date_time)}</td>
					<td data-visible='${this.visible[2]}'>${await this.key('companies', record.company_id) || ''}</td>
					<td data-visible='${this.visible[3]}'>${esc(record.integration_key)}</td>
					<td data-visible='${this.visible[4]}'>${esc(record.direction)}</td>
					<td data-visible='${this.visible[5]}'>${esc(record.status)}</td>
					<td data-visible='${this.visible[6]}'>${esc(record.summary)}</td>
					<td data-visible='${this.visible[7]}'>${formatPortalIntegradas(record)}</td>
					<td data-visible='${this.visible[8]}'>${esc(record.entity_type)}</td>
					<td data-visible='${this.visible[9]}'>${esc(record.entity_id)}</td>
					<td data-visible='${this.visible[10]}'>${esc(record.error_message)}</td>
					<td data-visible='${this.visible[11]}'>${esc(record.correlation_id)}</td>
					<td data-visible='${this.visible[12]}'>${esc(record.source)}</td>
					<td data-visible='${this.visible[13]}'>${await this.key('users', record.recorded_by) || ''}</td>
					<td data-visible='${this.visible[14]}'>${payloadCellPreview(record.request_payload)}</td>
					<td data-visible='${this.visible[15]}'>${payloadCellPreview(record.response_payload)}</td>
					<td data-visible='${this.visible[16]}'>${payloadCellPreview(record.error_stack)}</td>
				</tr>`
				))).join('') +
			`
			</tbody>
		</table>
	`;
};
